module.exports = __webpack_public_path__ + "31c067c13512224c8df41f48e689d722.png";